//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      hostName: "",
      hostPhoneNum: "",
      payWay: "",
      hotel: "",
      ArriveDate: "",
      // 到达时间
      unitName: "",
      address: "",
      remarks: "",
      zipCode: "",
      invoice: "",
      taxesNum: "",
      hotelNum: 0,
      tableData: [],
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      checkList: [],
      meetDetail: {}
    };
  },
  props: {
    signUpId: {
      type: String,
      default: ""
    },
    activityId: {
      type: String,
      default: ""
    }
  },
  created: function created() {
    this.getSignUpDetail();
    this.getMeetDetail();
  },
  methods: {
    getMeetDetail: function getMeetDetail() {
      var _this = this;

      this.$http.post("/api/XOrg/Special/getSpecialInfo", {
        id: this.activityId
      }).then(function (res) {
        if (res.code > 0) {
          _this.meetDetail = res.info;
        } else {
          _this.$message.warning(rst.msg);
        }
      });
    },
    getSignUpDetail: function getSignUpDetail() {
      var _this2 = this;

      this.$http.post("/api/XOrg/SpecialActivity/getMeetingEnrollInfo", {
        id: this.signUpId
      }).then(function (res) {
        if (res.code > 0) {
          _this2.hostName = res.info.CreateDisplayName;
          _this2.hostPhoneNum = res.info.CreateUserName;
          _this2.payWay = res.info.PaymentType == 0 ? "" : res.info.PaymentType;
          _this2.hotel = res.info.Hotel;
          _this2.ArriveDate = res.info.ArriveDate;
          _this2.unitName = res.info.CompanyName;
          _this2.address = res.info.Address;
          _this2.zipCode = res.info.ZipCode;
          _this2.invoice = res.info.Invoice;
          _this2.taxesNum = res.info.TaxNumber;
          _this2.remarks = res.info.Note;
          _this2.hotelNum = res.info.RoomCount;
          _this2.tableData = JSON.parse(res.info.EnterPerson);
          _this2.checkList = JSON.parse(res.info.InvoiceItem);
        }
      });
    },
    deleteEnroll: function deleteEnroll() {
      var _this3 = this;

      var that = this;
      this.$confirm("此操作将永久删除该报名记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        that.$http.post("/api/XOrg/MeetingEnroll/deleteEnroll", {
          id: _this3.signUpId
        }).then(function (res) {
          if (res.code > 0) {
            that.$message.success(res.msg);
            that.backSystem();
          } else {
            that.$message.warning(res.msg);
          }
        });
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    backSystem: function backSystem() {
      // this.$router.push({
      //   name:'basicInfo'
      // });
      this.$router.push({
        name: "MeetingEnrollManager",
        params: {
          activityId: this.activityId
        }
      }); // this.$router.go(-1);
    }
  }
};